import Layout from '../../internal/Layout.vue'
import StandardChecklistPage from './standardChecklist.vue'

const StandardChecklistRoutes = {
  component: Layout,
  children: [
    {
      name: 'StandardChecklist',
      path: '/',
      component: StandardChecklistPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
      },
    },
  ],
}

export default StandardChecklistRoutes
